import { render, staticRenderFns } from "./veSbzcJzwRoomShow.vue?vue&type=template&id=16ed1dea&scoped=true"
import script from "./veSbzcJzwRoomShow.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwRoomShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed1dea",
  null
  
)

export default component.exports